/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';

/* ============
 * Shims
 * ============
 *
 * Long live Internet explorer
 */
// import './shims/arrayFind';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */

import './plugins/vuex';
import './plugins/axios';
import './plugins/idle-vue';
import { router } from './plugins/vue-router';
import './plugins/vuex-router-sync';
import './plugins/vue-mq';
import './plugins/vue-body-class';
import { i18n } from './plugins/vue-i18n';
import './plugins/vue-select';
import './plugins/vue-tippy';
import './plugins/vuelidate';
import './plugins/vue-print-nb';

/* ============
 * Styling
 * ============
 */

import './assets/sass/main.scss';

/* ============
 * Global registrations
 * ============
 *
 * Register modules globally
 */
import './app/components/_register';
import './app/layouts/_register';
import './app/mixins/global/_register';

/* ============
 * Main App
 * ============
 */

import App from './App';
import store from './store';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  /**
   * Bind the Vue instance to the HTML.
   */
  el: '#app',

  /**
   * The localization plugin.
   */
  i18n,

  /**
   * The router.
   */
  router,

  /**
   * The Vuex store.
   */
  store,

  /**
   * Will render the application.
   */
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js